import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import Endpoints from "../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../base";
import { TeamType } from "../../domain/models/team";
import { FetchTeam } from "../../domain/useages/fetch-team";
import { RemoteFetchTeam } from "../../data/usecases/remote-fetch-team";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface FetchTeamInterface {
  teamData: TeamType[];
  fetchTeam: Function;
}

const initialStates = {
  teamData: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchTeamSlice: StateCreator<FetchTeamInterface> = (set) => ({
  ...initialStates,
  fetchTeam: async () => {
     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchTeamMaster: FetchTeam = new RemoteFetchTeam(
      `${BASE_URL}${Endpoints.FETCH_TEAMS}`,
      axiosHttpClient
    );

    let result = await remoteFetchTeamMaster.fetch();
    if (result.success) {
      set(() => ({ teamData: result.teams }));
    }
  },
});
